/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */
export enum FieldFilterRestrictionOperator {
    EQ = 'EQ',
    NE = 'NE',
    LT = 'LT',
    LE = 'LE',
    GT = 'GT',
    GE = 'GE',
    BETWEEN = 'BETWEEN',
    STARTS_WITH = 'STARTS_WITH',
    CONTAINS = 'CONTAINS',
    NOT_CONTAINS = 'NOT_CONTAINS',
    IN = 'IN',
    NOT_IN = 'NOT_IN',
    IS_EMPTY = 'IS_EMPTY',
    IS_PRESENT = 'IS_PRESENT'
}



